import { IonContent, IonFab, IonFabButton, IonIcon, IonLabel, IonLoading, IonPage, useIonViewDidEnter } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { urlBase } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './Galeria.css';
import GridImagens from './GridImagens';

const Galeria: React.FC = () => {

  const location = useLocation();
  const history = useHistory();
  const [showLoadingPage, setShowLoadingPage] = useState(false);
  const [stateListaImagens, setStateListaImagens] = useState<[]>([]);
  const [categoriaPortfolio, setCategoriaPortfolio] = useState<any>();
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  
  useIonViewDidEnter(() => {
        setEsconderMenu(true);

  });

  useEffect(() => {
    servicoBuscaGaleria();
    setCategoriaPortfolio((location.state ? atob((location.state as { categoria: string, descricao: string }).categoria) : ""));
  }, []);


  // Utilizado para carregas as imagens da tela referente a categoria selecionada na tela anterior
  async function servicoBuscaGaleria() {
    const consultar = async () => {

      setShowLoadingPage(true);

      const resp: Response = await fetch(urlBase.url + "/mobile/portfolio/" + (location.state ? atob((location.state as { categoria: string, descricao: string }).categoria) : "").replaceAll(/#/g, "%23").concat("?opcao=galeria"),
        {
          method: urlBase.method,
          headers: [
            ["token", localStorage.getItem("token") || ""],
            ["perfil", window.localStorage.getItem("perfil") || ""],
            ["marca", window.localStorage.getItem("marca") || ""],
          ],
          credentials: 'include'
        });
      await resp.json().then(async (res) => {

        if (resp.status === 400 || resp.status === 401) {
          history.replace("/login/");
        }

        if (res) {
          setStateListaImagens(res.Items);
          //history.push("galeria", { categoria: btoa(categoria) });
        }

      }).finally(() => {
        setShowLoadingPage(false);
      });
    }
    consultar();
  }

  return (
    <IonPage>
      <div id="galeriaFab">
        <IonFab slot="fixed" vertical="top" horizontal="start" style={{ paddingTop: '40px' }}><IonFabButton size='small' translucent={true} onClick={() => history.goBack()}><IonIcon color='primary' icon={arrowBack}></IonIcon></IonFabButton></IonFab>
      </div>

      <IonContent style={{ background: '#eeeeee' }} fullscreen class='ion-padding'>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '100px', paddingBottom: '70px' }}>
          <IonLabel style={{ width: '80%', textAlign: 'center', fontSize: '24px', fontWeight: 'bold' }}>
            {location.state ? (location.state as { categoria: string, descricao: string }).descricao : ""}
          </IonLabel>
        </div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div style={{ maxWidth: '1024px', width: '100%' }}>
            {(!stateListaImagens || stateListaImagens.length == 0) ? (
              <IonLabel style={{ fontSize: '18px', fontWeight: 'bold', display: 'flex', width: '100%', justifyContent: 'center' }}>
                Ainda não há imagens cadastradas.
              </IonLabel>
            ) : (
              <IonLabel style={{ fontSize: '18px', fontWeight: 'bold' }}>
                {stateListaImagens.length}{stateListaImagens.length < 2 ? ' imagem' : ' imagens'}
              </IonLabel>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px', paddingBottom: '50px' }}>
          <div id='container' style={{ maxWidth: '1024px' }}>
            <GridImagens lista={stateListaImagens} history={history} excluirFoto={null}></GridImagens>
          </div>
        </div>
      </IonContent>

      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoadingPage}
        onDidDismiss={() => { setShowLoadingPage(false); }}
        spinner='circles'
      />
    </IonPage>
  );

};

export default Galeria;
